var cmsId = {
    EmailLwkForm: '26',
    EilverfahrenHelp: '14',
};
export default cmsId;
